<template>
  <div>
    <MainNavBar />
    <Hero :hero="heroAconexHelp" />
    <Section :content="findOrgAdmin" />
    <Section :content="logIn" />
    <Section :content="viewProjectDocs" />
    <!--Section :content="uploadAndCrosslink" /-->
    <Section :content="navigate" />
    <Section :content="uploadFiles" />
    <Section :content="registerSpecs" />
    <Section :content="registerDrawings" />
    <GmxFooter />
  </div>
</template>

<script>
// @ is an alias to /src
require('@/assets/css/styles.css');
import MainNavBar from '@/components/main-nav-bar.vue';
import Hero from '@/components/hero.vue';
import Section from '@/components/section.vue';
import GmxFooter from '@/components/footer.vue';
export default {
  name: 'AconexHelp',
  components: {
    MainNavBar,
    Hero,
    Section,
    GmxFooter,
  },
  data() {
    return { 
      heroAconexHelp: { 
        eyebrowIcon: '',
        eyebrowTitle: '',
        eyebrowSubtitle: '',
        header: 'Aconex Accelerator Help',
        subheader: '',
        img: 'hero-help.png',
        videoId: '',
        buttons: [
          { label: 'Find Org Admin', path: '', id: 'find-org-admin' },
          { label: 'Log In', path: '', id: 'log-in' },
          { label: 'View Project Docs', path: '', id: 'view-project-docs' },
          { label: 'Navigation', path: '', id: 'navigate' },
          { label: 'Upload Files', path: '', id: 'upload-files' },
          { label: 'Register Specs', path: '', id: 'register-specs' },
          { label: 'Register Drawings', path: '', id: 'register-drawings' },
        ]
      },
      findOrgAdmin: {
        eyebrow: '',
        eyebrowIcon: '',
        headline: 'How to find the Organization Admin',
        paragraphs: [
          'To find the Organization Admin, log in to your Aconex Project and click on the question mark icon on the upper right corner of the interface.'
        ],
        id: 'find-org-admin',
        image: 'find-org-admin.png',
        videoId: '',
        colOrderText: 2,
        colOrderImage: 1,
        bgClass: 'bg-neon-blue-grad',
      },
      logIn: {
        eyebrow: '',
        eyebrowIcon: '',
        headline: 'How to Log In',
        paragraphs: [],
        id: 'log-in',
        image: '',
        videoId: '1013692710',
        colOrderText: 2,
        colOrderImage: 1,
        bgClass: 'bg-light-grad',
        html: '<div class="lead"><p>The Aconex Organization Administrator should first log in before any Aconex Project members can log in.</p><ol><li>Navigate to trinapp.com</li><li>Select “Oracle Partner Smart Construction”</li><li>Choose location EU or US (The Administrator chooses location on their first login)</li><li>Use your Oracle Smart Construction Credentials</li></ol></div>',
      },
      viewProjectDocs: {
        eyebrow: '',
        eyebrowIcon: '',
        headline: 'How to view documents in a project',
        paragraphs: [
          'After logging in, you will land on the Launchpad welcome screen. To view your projects, click on the Launch Pods button (1). You will then see a list of your projects. The Aconex synchronized CDE project will have a black bar on top of the icon.',
          'To view the documents inside a project, click on the Documents button (2) in the project\'s row.'
        ],
        id: 'view-project-docs',
        image: 'view-project-docs.png',
        videoId: '',
        colOrderText: 2,
        colOrderImage: 1,
        bgClass: 'bg-neon-blue-grad',
      },
      /*uploadAndCrosslink: {
        eyebrow: '',
        eyebrowIcon: '',
        headline: 'How to upload and Crosslink your documents',
        paragraphs: [
          'Upload the PDF into the document type you want to accelerate into Aconex, then click the Start button. You will get a notification when it is ready to review. After you approve the review and click the Accept and Save button, the Accelerator will notify you by email when it\'s complete. When you receive the email, the documents will be ready for search and have live links in the Accelerator.',
          'You can upload large drawing sets or specs as a single PDF. The Accelerator will automatically find all the information it can for you to review before saving to Aconex. It also separates it into separate sheets or sections for the review.'
        ],
        id: 'upload-and-crosslink',
        image: 'placeholder.png',
        colOrderText: 2,
        colOrderImage: 1,
        bgClass: 'bg-neon-blue-grad',
      },*/
      navigate: {
        eyebrow: '',
        eyebrowIcon: '',
        headline: 'Navigating the Aconex Accelerator',
        paragraphs: [],
        id: 'navigate',
        image: '',
        videoId: '1013694268',
        colOrderText: 2,
        colOrderImage: 1,
        bgClass: 'bg-light-grad',
        html: '<div class="lead"><p>Video contents:</p><ol><li>How to find help</li><li>How to switch between applications</li><li>How to navigate to your Aconex Project and its WIP</li><li>How to navigate to your documents</li><li>How to navigate between projects and other spaces</li><li>How to navigate to Search</li></ol></div>',
      },
      uploadFiles: {
        eyebrow: '',
        eyebrowIcon: '',
        headline: 'How to Upload Files',
        paragraphs: [],
        id: 'upload-files',
        image: '',
        videoId: '1013277374',
        colOrderText: 2,
        colOrderImage: 1,
        bgClass: 'bg-neon-blue-grad',
        html: '<div class="lead"><ol><li>In the Accelerator, navigate to the Aconex Project CDE and open the Documents application.</li><li>Select the Document type</li><li>For single file uploads, drag and drop the file into the selected Document type, or click the “Upload File” button<br>For multiple files, compress the documents into one compressed file (like a zip file) and click the “Upload Compressed File” button</li></ol></div>',
      },
      registerSpecs: {
        eyebrow: '',
        eyebrowIcon: '',
        headline: 'How to Register Specs',
        paragraphs: [],
        id: 'register-specs',
        image: '',
        videoId: '1013251221',
        colOrderText: 2,
        colOrderImage: 1,
        bgClass: 'bg-light-grad',
        html: '<div class="lead"><ol><li>Upload the specifications into the Specification Container and press Start</li><li>After receiving an email letting you know it is ready for review, navigate to the Specification and press the Review button. If there isn\'t a Review button, expand the document using the caret and do each Review in order.</li><li>Review and edit the fields where needed. When all is correct, press Accept and Save.</li></ol></div>'
      },
      registerDrawings: {
        eyebrow: '',
        eyebrowIcon: '',
        headline: 'How to Register Drawings',
        paragraphs: [],
        id: 'register-drawings',
        image: '',
        videoId: '1014881164',
        colOrderText: 2,
        colOrderImage: 1,
        bgClass: 'bg-neon-blue-grad',
        html: '<div class="lead"><ol><li>Upload the drawings into the Drawings Container and press Start</li><li>After receiving an email letting you know it is ready for review, navigate to the Drawings and press the Review button. If there isn\'t a Review button, expand the document using the caret and do each Review in order.</li><li>Review and edit the fields where needed. When all is correct, press Accept and Save.</li></ol></div>'
      },
    }
  },
    mounted() {
	if (window.location.search === '?scroll=true'){
	    this.scrollToClass();
	}
  },
  methods: {
    scrollToClass: function() {
      const element = document.querySelector(`.${'display-4'}`);
      element.scrollIntoView({
          behavior: 'smooth'
        });
    },
    scrollToTargetAdjusted: function() {
        var element = document.querySelector(`.${'display-4'}`);
        var headerOffset = 60;
        var elementPosition = element.getBoundingClientRect().top;
        var offsetPosition = elementPosition + window.scrollY - headerOffset;
      
        window.scrollTo({
            top: offsetPosition,
            behavior: "smooth"
        });
    }
  }
};
</script>
